<div id="mySidenav" [ngClass]="showEventFilter ? 'sidenavopened': 'sidenav' ">
  <h4 class="font-md">
    <span class="font-md col-12">{{this.filterEventHistoryLabel}} </span><br><span class="font-xs col-12 start-left">{{
      AgentLanId}}</span>
  </h4>
  <a href="javascript:void(0)" class="closebtn" (click)="toggleFilter()">&times;</a>
  <div class="input-group search-container">
    <input type="text" class="rounded-pill form-control search-bar card-comments text-break"
      placeholder="{{this.searchEventLabel}}" aria-label="Search" maxlength="30" aria-describedby="basic-addon2"
      [(ngModel)]="searchText">
    <div class="input-group-append search-icon">
      <button type="button" class="btn bg-outline-secondary px-2 m-0 py-0" style="border:0;cursor:default;">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-search"
          viewBox="0 0 16 16">
          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 
                      1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 
                       1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 
                      1 1-11 0 5.5 5.5 0 0 1 11 0z" />
        </svg></button>
    </div>
  </div>
  <div class=" h-70 overflow-auto custom-area">
    <ng-container *ngFor="let event of violationsKeys">
      <div class=" pt-2 border-bottom-1" *ngIf="events[event] && events[event].Show">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" name="team" [(ngModel)]="events[event].checked" name="events"
            value={{event}} id={{event}}>
          <label class="form-check-label font-sm" for={{event}}>
            {{event}}
          </label>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="modal-footer pt-2 pb-0">
    <button type="button" class="btn button-primary me-2" data-bs-toggle="tooltip" data-bs-placement="top"
      title="{{this.applyFiltersLabel}}" (click)="filterEvent(true)">{{this.applyLabel}}</button>
    <button type="button" class="btn button-danger" data-dismiss="modal" data-bs-toggle="tooltip"
      data-bs-placement="top" title="{{clearFiltersLabel}}" (click)="clear()">{{this.clearLabel}}</button>
  </div>
</div>